import { AbstractControl } from '@angular/forms';

export function ValidateEmptyOrObject(control: AbstractControl) {
  if ((typeof control.value === 'object') || control.value === '') {
    return null;
  }
  return {invalidObject: true};
}
